/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import { View, Text, Image, SafeAreaView } from 'react-native'
import styles from './styles';
import {Icon} from 'react-native-elements'
import AppIntroSlider from 'react-native-app-intro-slider';
import { LinearGradient } from 'expo-linear-gradient';
import { TutorialDeviceStorage } from '../../utilities'
import { SvgUri } from 'react-native-svg';

export default function Tutorial(props) {
const { navigation } = props;

const slides = [
  {
    key: 1,
    title: 'Welcome',
    text: 'Let\'s Take A Tour',
    media: {
    type: 'image',
    uri: require('../../../assets/empireLogoTransparent.png')
    }
  },
   {
     key: 2,
     title: 'Notifications',
     text: `Allow push notification to be notified with:\n\n🏷 Pricing alerts\n🆕 Product changes\n📢 Announcements\n\nYou can always make changes to these preferences within the settings menu.`,
     media: {
     type: 'illustration',
     uri: "https://firebasestorage.googleapis.com/v0/b/empire-distributing.appspot.com/o/Onboarding%2FnotificationsOutline.svg?alt=media&token=34c83634-cc80-45dd-9f36-3794f9809c1f",
   }
   },
   {
     key: 4,
     title: 'Activity Feed',
     text: `Keep up-to-date with the most current product updates and catalog changes.\n\nFind what you need quickly, and simply with search, favorites, and filters.`,
     media: {
     type: 'illustration',
     uri: "https://firebasestorage.googleapis.com/v0/b/empire-distributing.appspot.com/o/Onboarding%2FonlineResearch.svg?alt=media&token=0bd5767d-c5ae-42d8-92e9-d6996db08ace",
   }
   },
   {
   key: 5,
   title: 'Catalogs',
   //text: 'Access digital catalogs on all of your devices. Catalogs are always up-to-date with current product and price offerings.',
   text: `Access digital catalogs on all of your devices.\n\nCatalogs are always up-to-date with current product and price offerings.`,
   media: {
   type: 'illustration',
   uri: 'https://firebasestorage.googleapis.com/v0/b/empire-distributing.appspot.com/o/Onboarding%2FmobilePhonePerson.svg?alt=media&token=ae237d73-43cc-4a6d-86d0-e7440e15d88f',
   }
   },
   {
   key: 6,
   title: 'Sales Rep',
 //text: `Contact your sales rep from the app via: \n\n📞 Call, 💬 Text, and 📧 Email`,
   text: `Contact your sales rep from the app via: \n\nCall, Text, and Email.`,
   media: {
   type: 'illustration',
   uri: 'https://firebasestorage.googleapis.com/v0/b/empire-distributing.appspot.com/o/Onboarding%2FmobilePhone.svg?alt=media&token=500b5905-b23d-40cc-bec0-f0c0b2dbaf78'
   }
   },
   {
   key: 7,
   title: 'All Set',
   text: `This tutorial can be viewed again from the settings screen if you need to revisit.\n\nEnjoy!`,
   media: {
   type: 'illustration',
   uri: "https://firebasestorage.googleapis.com/v0/b/empire-distributing.appspot.com/o/Onboarding%2FGetting%20Started.svg?alt=media&token=11138058-eb8b-4410-81ec-605c6cd5feac",
   }
   }
];


 const renderItem = ({ item }) => {
    return (
      <View style={styles.slide}>
        <Text style={styles.title}>{item.title}</Text>
        {item.media.type === 'image'? (
        <Image
        source={item.media.uri}
        style={{resizeMode: 'contain', padding: '30%'}}
        />
        ) : (
        <SvgUri
         uri={item.media.uri}
        />
        )}
       <Text style={styles.text}>{item.text}</Text>
      </View>
    );
  }

  const tutorialComplete = async () => {
  await TutorialDeviceStorage.setShouldShowTutorial('false');
  const canGoBack = navigation.canGoBack();
  if (canGoBack) {
  navigation.goBack();
  }
  else {
  navigation.navigate('Login');
  }

  }


   const _renderNextButton = () => {
      return (
        <View style={styles.buttonCircle}>
          <Icon
            name="arrow-forward-ios"
            color="rgba(255, 255, 255, .9)"
            size={24}
          />
        </View>
      );
    };
   const _renderDoneButton = () => {
      return (
        <View style={styles.buttonCircle}>
          <Icon
            name="done"
            //color="rgba(255, 255, 255, .9)"
            color="green"
            size={24}
          />
        </View>
      );
    };

return (
<LinearGradient
colors={['black', '#590000']}
locations={[.1,1]}
style={{flex: 1}}
>
<SafeAreaView style={styles.container}>
<AppIntroSlider
renderItem={renderItem}
data={slides}
renderNextButton={_renderNextButton}
renderDoneButton={_renderDoneButton}
backLabel={"Back"}
nextLabel={"Next"}
doneLabel={"Done"}
skipLabel={"Skip"}
showSkipButton={true}
showPrevButton={true}
dotClickEnabled={true}
onDone={() => {tutorialComplete()}}
/>
</SafeAreaView>
</LinearGradient>
)
}